const getClassName = (classes: string[] = []) => classes.join(' ');
export default getClassName;
